import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { sizes } from '../../const/sizes';
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
import { getTagBackgroundColor, getTagSpacings, getTagTextColor, getTagTextVariant, } from './tagConst';
const StyledTag = styled('div', (p) => ({
    backgroundColor: p.$backgroundColor,
    borderRadius: sizes.tag.borderRadius,
    width: 'fit-content',
}));
export const Tag = ({ title, color, size = 'medium', textAlign = 'justify', testId, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const tagBackgroundColor = getTagBackgroundColor(color);
    const textColor = getTagTextColor(color);
    const spacings = getTagSpacings(size);
    const textVariant = getTagTextVariant(size);
    return (_jsx(StyledTag, { $backgroundColor: tagBackgroundColor, ...testIdAttribute, children: _jsx(FlexContainer, { direction: 'column', ...spacings, center: true, children: _jsx(Text, { color: textColor, variant: textVariant, align: textAlign, children: title }) }) }));
};
